import { $, $$ } from 'src/shared/js/utils/dom';
import AniScroll from 'src/shared/js/modules/ani-scroll';

class Jumpmarks {
  constructor(options) {
    this.container = options.container;
    this.links = $$('a', this.container);
  }

  jumpToAnchor = e => {
    const targetId = e.currentTarget.hash;
    const targetPath = e.currentTarget.pathname;
    const target = $(targetId);
    let scrollToPosition;

    if (target && window.location.pathname === targetPath) {
      e.preventDefault();
      scrollToPosition = target.offsetTop;

      AniScroll(scrollToPosition, 500, 'easeOutQuad', () => {
        target.setAttribute('tabindex', '0');
        target.focus();
        this.setUrlHash(targetId);
      });
    } else {
      console.error(`element ${target} does not exist`);
    }
  };

  setUrlHash = id => (window.location.hash = id);

  init = () => {
    this.links.forEach(link => {
      link.addEventListener('click', this.jumpToAnchor);
    });
  };
}

const jumpmarks = $$('.jumpmarks');

jumpmarks.length &&
  jumpmarks.forEach(jumpmark => {
    new Jumpmarks({
      container: jumpmark,
    }).init();
  });
